import React, { useMemo, useState } from "react";
import axios from "../../utils/axiosInstance";
import { useNavigate, useParams } from "react-router-dom";

export default function ResetPassword() {
  const { token } = useParams();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [saving, setSaving] = useState(false);
  const navigate = useNavigate();

  const canSubmit = useMemo(() => {
    return (
      String(password || "").trim().length >= 6 &&
      String(confirm || "").trim().length >= 6 &&
      password === confirm &&
      Boolean(token)
    );
  }, [password, confirm, token]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    const cleanPw = String(password || "").trim();
    const cleanConfirm = String(confirm || "").trim();

    if (cleanPw.length < 6) {
      setError("Password must be at least 6 characters.");
      return;
    }
    if (cleanPw !== cleanConfirm) {
      setError("Passwords do not match.");
      return;
    }
    if (!token) {
      setError("Invalid reset token.");
      return;
    }

    try {
      setSaving(true);
      const res = await axios.post(`/auth/resetPassword/${token}`, { password: cleanPw });

      setSuccess(res.data.message || "Password reset successfully!");
      setTimeout(() => navigate("/login"), 2500);
    } catch (err) {
      console.error("Reset password error:", err);
      setError(err.response?.data?.message || "Error resetting password.");
    } finally {
      setSaving(false);
    }
  };

  if (success) {
    return (
      <div className="min-h-screen flex items-center justify-center px-4">
        <div className="bg-green-100 border border-green-400 text-green-700 px-6 py-4 rounded shadow text-center w-full max-w-sm">
          <h2 className="text-xl font-bold mb-2">Success!</h2>
          <p>{success}</p>
          <p className="mt-4 text-sm text-gray-600">Redirecting to login...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center px-4">
      <form onSubmit={handleSubmit} className="bg-white p-6 rounded shadow w-full max-w-sm">
        <h2 className="text-xl font-bold mb-4 text-center">Reset Password</h2>

        {error && <div className="text-red-500 text-sm mb-3 text-center">{error}</div>}

        <input
          type="password"
          placeholder="New Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="w-full p-2 border mb-3 rounded"
          required
          minLength={6}
        />

        <input
          type="password"
          placeholder="Confirm New Password"
          value={confirm}
          onChange={(e) => setConfirm(e.target.value)}
          className="w-full p-2 border mb-4 rounded"
          required
          minLength={6}
        />

        <button
          type="submit"
          disabled={!canSubmit || saving}
          className="bg-blue-500 text-white px-4 py-2 rounded w-full hover:bg-blue-600 transition disabled:opacity-50"
        >
          {saving ? "Saving..." : "Reset Password"}
        </button>
      </form>
    </div>
  );
}
